import { BACKEND_URI } from "../entries"
import { getCookie } from "../utils"
import { devLog } from "./loggerUtils"


export const secureAPICall = async ({ endpoint, body = {}, method = "POST", options = {}, verbose = false }) => {

    const csrfToken = getCookie("Mobile2CredentialsManager.CSRFToken")

    const response = await fetch(endpoint, {
        method: method,
        body: body,
        ...options,
        headers: {
            ...options.headers,
            'X-CSRF-Token': csrfToken,
        },
        credentials: "include"
    })

    const result = await response.json()
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    else {

        if (verbose) {
            devLog(result.status, result.message)
            devLog(result)
        }
        return result.data

    }
}


export const requestTest = () => {
    const formData = new FormData()
    formData.append("test_param", "Hello from the front")
    return secureAPICall({ endpoint: BACKEND_URI + "/auth/test", body: formData, options: { mode: "cors" }, verbose: true })

}